require('../../../modules/es.array.iterator');
require('../../../modules/es.object.to-string');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').keys;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/array/virtual/keys.js
// module id = 383
// module chunks = 0 1